export default "__VITE_ASSET__958fe2d9__"